import React from 'react';
import Layout from './Layout';
import ChangePasswordForm from './ChangePasswordForm';
import SignInLink from './Links/SignInLink';

export default function ResetPassword({ onSubmit, error }) {
  return (
    <Layout title="Reset Password">
      <ChangePasswordForm onSubmit={onSubmit} error={error} />
      <SignInLink text="Don't need to reset your password?" />
    </Layout>
  );
}
